<template>
  <div class="home-top">
    <div class="top-left">
      <div class="old">
        <div class="old-icon">
          <img src="../../../assets/icon_user.png" alt="" />
        </div>
        <div class="old-num">
          <div class="old-number">{{ topData.bedCount || "--" }}</div>
          <div class="old-title">守护老人数量</div>
        </div>
      </div>
      <div class="old" style="margin-top: 10px">
        <div class="old-icon">
          <img src="../../../assets/icon_deepSleep.png" alt="" />
        </div>
        <div class="old-num">
          <div class="old-number">{{ topData.sleepScore || "--" }}</div>
          <div class="old-title">睡眠得分中位数</div>
        </div>
      </div>
    </div>

    <div class="top-right">
      <div class="sleep-top">
        <div class="sleep-title">整体睡眠数据</div>
        <div class="sleep-desc">过去7天</div>
        <div class="sleep-more" @click="goHealth">查看更多</div>
      </div>
      <div class="sleep-charts" v-show="visible()">
        <div class="sleep-chart" id="sleepChartScore" style="height: 133px; margin: 10px auto;" key="sleepChartScore"></div>
        <div class="sleep-chart" id="sleepChartHealth" style="height: 146px; margin: 10px auto" key="sleepChartHealth"></div>
        <div class="sleep-chart sleep-chart-police" id="sleepChartPolice" style="height: 146px; margin: 10px auto" key="sleepChartPolice"></div>
        <div class="sleep-chart sleep-chart-police2" id="sleepChartPolice2" style="height: 146px; margin: 10px auto" key="sleepChartPolice2"></div>
        <div class="chart-name1">睡眠得分</div>
        <div class="chart-name2">呼吸慢病</div>
        <div class="chart-name3">异常报警</div>
      </div>
      <a-empty v-show="!visible()" description="暂无内容哦" style="margin:10px;"></a-empty>
    </div>
  </div>
</template>

<script>
import Global from "../../../utils/global";
export default {
  props: {
    healthBigData: null,
  },
  data() {
    return {
      sleepChartScore: null,
      sleepChartHealth: null,
      sleepChartPolice: null,
      sleepChartPolice2: null,
      topData: {},
      topEmpty: null,
      topZero: null,
      leaveBedInterval: 0,
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      this.$get(
        "/api/deanData/getWholeSleep",
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              if (!res.data.sleep) {
                res.data.sleep = {};
              }
              if (!res.data.warning) {
                res.data.warning = {};
              }
              if (!res.data.breathing) {
                res.data.breathing = {};
              }
              this.topData = res.data;
              console.log(this.topData);
              setTimeout(() => {
                that.getSleepChartScore();
                that.getSleepChartHealth();
                that.getSleepChartPolice();
                that.getSleepChartPolice2();
              }, 500);
            } else {
              this.topEmpty = true;
            }
            this.isZero();
          } else {
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },

    isZero() {
      var sleep = false;
      var breathing = false;
      var warning = false;
      if (
        this.topData.sleep.high ||
        this.topData.sleep.millde ||
        this.topData.sleep.low
      )
        sleep = true;
      if (
        this.topData.breathing.high ||
        this.topData.breathing.millde ||
        this.topData.breathing.low
      )
        breathing = true;
      if (
        this.topData.warning.breathingFast ||
        this.topData.warning.breathingStop ||
        this.topData.warning.fall ||
        this.topData.warning.heartbeatFast ||
        this.topData.warning.heartbeatSlow ||
        this.topData.warning.leaveBed
      )
        warning = true;
      this.topZero = !(sleep || breathing || warning);
    },

    goHealth() {
      this.$parent.tabClick2(2);
      //   Global.$emit("tabClick2", {
      //     type: 3,
      //   });
      //   localStorage.setItem("index2", 3);
      //   this.$router.replace({
      //     path: "/dean/oldHealthy",
      //     query: {},
      //   });
      // this.$router.push({
      //   path: "/dean/oldHealthy",
      // });
    },
    //报警图表
    setInterval() {
      var i = 10;
      for (i; ; i = i * 10) {
        if (this.topData.warning.leaveBed / i <= 1) break;
      }
      if (
        this.topData.warning.leaveBed >= i / 10 &&
        this.topData.warning.leaveBed < i / 2
      )
        this.leaveBedInterval = i / 10;
      else this.leaveBedInterval = i / 5;
    },
    getSleepChartPolice() {
      var that = this;
      //var policeData = this.topData.
      var policeData = [];
      policeData.push(this.topData.warning.leaveBed || 0);
      // policeData.push(this.topData.warning.fall || 0);
      // policeData.push(this.topData.warning.breathingStop || 0);
      // policeData.push(this.topData.warning.breathingFast || 0);
      // policeData.push(this.topData.warning.heartbeatFast || 0);
      // policeData.push(this.topData.warning.heartbeatSlow || 0);
      //   policeData.push(this.topData.warning.middle);
      //   policeData.push(this.topData.warning.high);
      this.sleepChartPolice = this.$echarts.init(
        document.getElementById("sleepChartPolice")
      );
      this.setInterval();
      var option = {
        color: ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
          formatter: function (params) {
            var res =
              "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" +
              params[0].name +
              " </p></div>";
            for (var i = 0; i < params.length; i++) {
              res += `<div style="color: #000;font-size: 8px;line-height: 16px">
					<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[
            params[i].color,
          ]};"></span>
					<span style="font-weight:bold;font-size:14px;opacity:0.6;">${
            params[i].data
          }次</span>
					</div>`;
            }
            return res;
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            // name: "异常报警", //坐标名字
            // nameLocation: "end", //坐标位置，支持start,end，middle
            // nameTextStyle: {
            //   padding: [10, 0, 0, 0], // 四个数字分别为上右下左与原位置距离
            // },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
              formatter: function (val) {
                var strs = val.split(""); //字符串数组
                var str = "";
                for (var i = 0, s; (s = strs[i++]); ) {
                  //遍历字符串数组
                  str += s;
                  if (!(i % 4)) str += "\n";
                }
                return str;
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: ["离床报警次数"],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            z: 10,
            minInterval: this.leaveBedInterval,
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,

              show: true,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barGap: 0,
            barWidth: 20,
            // barCategoryGap: 1,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            data: policeData,
          },
        ],
      };
      this.sleepChartPolice.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartPolice.resize();
      });
    },
    getSleepChartPolice2() {
      var that = this;
      //var policeData = this.topData.
      var policeData = [];
      var policeXData = [];
      //policeData.push(this.topData.warning.leaveBed || 0);
      policeData.push(this.topData.warning.fall || 0);
      policeData.push(this.topData.warning.breathingStop || 0);
      policeData.push(this.topData.warning.breathingFast || 0);
      policeData.push(this.topData.warning.heartbeatFast || 0);
      policeData.push(this.topData.warning.heartbeatSlow || 0);
      // if(this.topData.warning.fall){
      //  policeData.push(this.topData.warning.fall || 0);
      //  policeXData.push("跌倒次数");
      // }
      // if(this.topData.warning.fall){
      // 		  policeData.push(this.topData.warning.breathingStop || 0);
      // 		  policeXData.push("呼吸暂停过久");
      // }
      // if(this.topData.warning.fall){
      // 		  policeData.push(this.topData.warning.breathingFast || 0);
      // 		  policeXData.push("呼吸过速");
      // }
      // if(this.topData.warning.fall){
      // 		  policeData.push(this.topData.warning.heartbeatFast || 0);
      // 		  policeXData.push("心跳过速");
      // }
      // if(this.topData.warning.fall){
      // 		  policeData.push(this.topData.warning.heartbeatSlow || 0);
      // 		  policeXData.push("心跳过缓");
      // }
      //   policeData.push(this.topData.warning.middle);
      //   policeData.push(this.topData.warning.high);
      this.sleepChartPolice2 = this.$echarts.init(
        document.getElementById("sleepChartPolice2")
      );
      var option = {
        color: ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
          formatter: function (params) {
            var res =
              "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" +
              params[0].name +
              " </p></div>";
            for (var i = 0; i < params.length; i++) {
              res += `<div style="color: #000;font-size: 8px;line-height: 16px">
					<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[
            params[i].color,
          ]};"></span>
					<span style="font-weight:bold;font-size:14px;opacity:0.6;">${
            params[i].data
          }次</span>
					</div>`;
            }
            return res;
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            // name: "异常报警", //坐标名字
            // nameLocation: "end", //坐标位置，支持start,end，middle
            // nameTextStyle: {
            //   padding: [10, 0, 0, 0], // 四个数字分别为上右下左与原位置距离
            // },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
              formatter: function (val) {
                var strs = val.split(""); //字符串数组
                var str = "";
                for (var i = 0, s; (s = strs[i++]); ) {
                  //遍历字符串数组
                  str += s;
                  if (!(i % 4)) str += "\n";
                }
                return str;
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: [
              "跌倒次数",
              "呼吸暂停过久",
              "呼吸过速",
              "心跳过速",
              "心跳过缓",
            ],
            //data: policeXData,
          },
        ],
        yAxis: [
          {
            type: "value",
            //show: policeXData.length != 0,
            splitLine: {
              show: false,
            },
            z: 10,
            minInterval: 10, //设置最小间隔为1，防止出现小数
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,
              show: true,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barGap: 0,
            barWidth: 20,
            // barCategoryGap: 1,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            data: policeData,
          },
        ],
      };
      this.sleepChartPolice2.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartPolice2.resize();
      });
    },
    //呼吸慢病图表
    getSleepChartHealth() {
      var that = this;
      var healthData = [];
      healthData.push(this.topData.breathing.low || 0);
      healthData.push(this.topData.breathing.middle || 0);
      healthData.push(this.topData.breathing.high || 0);
      this.sleepChartHealth = this.$echarts.init(
        document.getElementById("sleepChartHealth")
      );
      var option = {
        color: ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
          formatter: function (params) {
            var res =
              "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" +
              params[0].name +
              " </p></div>";
            for (var i = 0; i < params.length; i++) {
              res += `<div style="color: #000;font-size: 8px;line-height: 16px">
					<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[
            params[i].color,
          ]};"></span>
					<span style="font-weight:bold;font-size:14px;opacity:0.6;">${
            params[i].data
          }人次</span>
					</div>`;
            }
            return res;
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },

            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
              formatter: function (val) {
                var strs = val.split(""); //字符串数组
                var str = "";
                for (var i = 0, s; (s = strs[i++]); ) {
                  //遍历字符串数组
                  str += s;
                  if (!(i % 3)) str += "\n";
                }
                return str;
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: ["疑似低风险", "疑似中风险", "疑似高风险"],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            z: 10,
            //max: 30,
            minInterval: 10, //设置最小间隔为1，防止出现小数
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,
              show: true,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barGap: 0,
            barWidth: 20,
            // barCategoryGap: 1,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            data: this.healthBigData[3].enable == 1 ? healthData : [0, 0, 0],
          },
        ],
      };
      this.sleepChartHealth.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartHealth.resize();
      });
    },
    //得分图表
    getSleepChartScore() {
      var that = this;
      var scoreData = [];
      scoreData.push(this.topData.sleep.low || 0);
      scoreData.push(this.topData.sleep.middle || 0);
      scoreData.push(this.topData.sleep.high || 0);

      this.sleepChartScore = this.$echarts.init(
        document.getElementById("sleepChartScore")
      );
      var option = {
        color: ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
          formatter: function (params) {
            var res =
              "<div style='margin-bottom:5px;width:100%;height:18px;line-height:12px;border-radius:3px;'><p>" +
              params[0].name +
              " </p></div>";
            for (var i = 0; i < params.length; i++) {
              res += `<div style="color: #000;font-size: 8px;line-height: 16px">
					<span style="display:inline-block;border-radius:20px;width:10px;height:10px;background-color:${[
            params[i].color,
          ]};"></span>
					<span style="font-weight:bold;font-size:14px;opacity:0.6;">${
            params[i].data
          }人次</span>
					</div>`;
            }
            return res;
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },

            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 0,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            // data: ['20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00']
            data: ["0~59", "60~84", "85及以上"],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            z: 10,
            // max: 100,
            minInterval: 10, //设置最小间隔为1，防止出现小数
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 5,
              show: true,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barGap: 0,
            barWidth: 20,
            // barCategoryGap: 1,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            data: this.healthBigData[3].enable == 1 ? scoreData : [0, 0, 0],
          },
        ],
      };
      this.sleepChartScore.setOption(option);
      window.addEventListener("resize", () => {
        this.sleepChartScore.resize();
      });
    },
    visible: function () {
      return !(this.topEmpty || this.topZero || 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.home-top {
  width: 100%;
  height: 230px;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  .top-left {
    width: 170px;
    height: 220px;
    display: inline-block;
    .old {
      width: 170px;
      height: 105px;
      background: white;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .old-icon {
        margin-left: 15px;
        img {
          width: 50px;
        }
      }
      .old-num {
        margin-left: 13px;
        width: 110px;
        text-align: left;
        .old-number {
          color: #262626;
          line-height: 42px;
          font-size: 38px;
          font-weight: 300;
        }
        .old-title {
          color: #8c8c8c;
          line-height: 20px;
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
    .score {
      margin-top: 10px;
      width: 170px;
      height: 105px;
      background: white;
      border-radius: 8px;
    }
  }
  .top-right {
    width: 1000px;
    height: 220px;
    background: white;
    border-radius: 8px;
    display: inline-block;
    margin-left: 10px;

    .sleep-top {
      width: 100%;
      .sleep-title {
        font-size: 16px;
        color: #262626;
        line-height: 20px;
        display: inline-block;
        margin: 15px 0 0 15px;
      }
      .sleep-desc {
        color: #8c8c8c;
        line-height: 14px;
        font-size: 10px;
        display: inline-block;
        margin-left: 8px;
        position: relative;
        top: 2px;
      }
      .sleep-more {
        float: right;
        position: relative;
        top: 15px;
        right: 15px;
        color: #1890ff;
        line-height: 18px;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .sleep-charts {
      width: 950px;
      margin: 0 15px;
      height: 180px;
      .sleep-chart {
        width: 250px;
        float: left;
      }
      .sleep-chart-police {
        width: 100px;
      }
      .sleep-chart-police2 {
        width: 350px;
      }
    }
    .chart-name1 {
      width: 250px;
      height: 5%;
      position: relative;
      bottom: 8px;
      text-align: center;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.35);
    }
    .chart-name2 {
      width: 250px;
      height: 5%;
      position: relative;
      left: 250px;
      bottom: 8px;
      text-align: center;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.35);
    }
    .chart-name3 {
      width: 350px;
      height: 5%;
      position: relative;
      left: 600px;
      bottom: 8px;
      text-align: center;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
}
</style>